<script>
import MainBanner from '@/views/main/components/MainBanner.vue'
import MainFunction from '@/views/main/components/MainFunction.vue'
import MainVideoBanner from '@/views/main/components/MainVideoBanner.vue'
import QaBlock from '@/views/main/components/QaBlock.vue'
import TopList from '@/views/main/components/TopList.vue'
import MainNews from '@/views/main/components/MainNews.vue'

export default {
	name: 'MainPage',
	components: {
		MainBanner,
		MainFunction,
		MainVideoBanner,
		QaBlock,
		TopList,
		MainNews,
	},
	head: {
		title() {
			return {
				inner: this.$t('site.home.title'),
			}
		},
		meta: function () {
			return [{ name: 'description', content: this.$t('site.recovery.description') }]
		},
	},
}
</script>

<template>
	<div class="wrap__content relative overflow-hidden">
		<div
			class="absolute top-[20%] left-1/2 transform -translate-x-1/2 w-[1914px] h-[1914px] rounded-full bg-gradient-to-b from-white to-[#F5FCFF]"
		></div>

		<div class="absolute top-[79%] w-full h-[1100px] overflow-hidden">
			<div
				class="absolute top-0 left-1/2 transform -translate-x-1/2 w-[1914px] h-[1914px] rounded-full bg-gradient-to-b from-[#F5FCFF] to-white"
			></div>
		</div>
		<MainBanner />
		<MainFunction />
		<MainVideoBanner />
		<QaBlock />
		<TopList />
		<MainNews />
	</div>
</template>

<style></style>
